import { buildGlobalAction, buildInlineComputedView } from "./../../builder.js";
class RecoverySharedNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the ReportDataFactory global action. */
    this.ReportDataFactory = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "ReportDataFactory",
      operationName: "ReportDataFactory",
      operationReturnType: "RecoverySharedReportDataFactory",
      namespace: ["recovery", "shared"],
      variables: {}
    });
    /** Executes the generateRandomString global action. */
    this.generateRandomString = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateRandomString",
      operationName: "generateRandomString",
      operationReturnType: "RecoverySharedGenerateRandomString",
      namespace: ["recovery", "shared"],
      variables: {}
    });
    /** Executes the recipients global action. */
    this.recipients = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "recipients",
      operationName: "recipients",
      operationReturnType: "RecoverySharedRecipients",
      namespace: ["recovery", "shared"],
      variables: {}
    });
    /** Executes the reportData global action. */
    this.reportData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "reportData",
      operationName: "reportData",
      operationReturnType: "RecoverySharedReportData",
      namespace: ["recovery", "shared"],
      variables: {}
    });
    /** Executes the sendEmail global action. */
    this.sendEmail = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendEmail",
      operationName: "sendEmail",
      operationReturnType: "RecoverySharedSendEmail",
      namespace: ["recovery", "shared"],
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: ["recovery", "shared"],
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  RecoverySharedNamespace
};
//# sourceMappingURL=shared.js.map
